"use client";

import { useState, useEffect, useRef } from "react";
import GpuWidget from "./GpuWidget";
import PowerWidget from "./PowerWidget";
import CookieComplianceTester from "./CookieComplianceTester";

export default function Footer() {
  const [llmModel, setLlmModel] = useState("…");
  const openAuditRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    fetch("/api/system/config")
      .then((r) => r.json())
      .then((d) => { if (d.llm_model) setLlmModel(d.llm_model); })
      .catch(() => {});
  }, []);
  return (
    <footer className="bg-gray-900 text-gray-400 py-10 px-4 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold"
                style={{ background: "linear-gradient(135deg, #2d6a4f, #52b788)" }}>
                A
              </div>
              <span className="font-bold text-white">Lokalt Innovations hus i Haslev by</span>
            </div>
            <p className="text-sm leading-relaxed">
              Et kulturelt samlingssted i Haslev, dedikeret til scenekunst, innovation
              og eksperimenterende projekter for både børn, unge og voksne.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Hurtige links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Program</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Forestillinger</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Workshops & Events</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Kontakt os</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Om os</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-green-500" />
                <span>Scenekunst for alle aldre</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-green-500" />
                <span>Innovation og eksperiment</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-blue-400" />
                <span>Kulturelt samlingssted i Haslev</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs">
          <div className="flex items-center gap-3 flex-wrap justify-center md:justify-start">
            <span>© 2026 Lokalt Innovations hus i Haslev by. Drevet af {llmModel} + RAG.</span>
            <button
              onClick={() => openAuditRef.current?.()}
              className="flex items-center gap-1 px-2.5 py-1 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-300 hover:text-white transition-colors border border-gray-700 text-xs"
              title="Kør AI cookie-compliance audit"
            >
              🔍 Cookie-audit
            </button>
          </div>
          <span>Powered by Ollama · ChromaDB · MongoDB · Next.js</span>
        </div>

        <GpuWidget />
        <PowerWidget />
      </div>
    </footer>
  );
}
